import { compose } from "redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import React, { PureComponent } from "react";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";

import { SORT_DIRECTION } from "features/planner/planner.constants";

class SortableListHeader extends PureComponent {
  renderSortIcon = sortDirection => {
    const { classes, sortDirection: currentSortDirection } = this.props;

    return React.createElement(
      sortDirection === SORT_DIRECTION.ASC ? ArrowDropUp : ArrowDropDown,
      {
        className: classNames(
          sortDirection === SORT_DIRECTION.ASC
            ? classes.sortArrowIconAsc
            : classes.sortArrowIconDesc,
          {
            [classes.visibleArrowIcon]: currentSortDirection === sortDirection,
          },
        ),
      },
    );
  };

  renderTitle = (title, isColumnSortable) => {
    const { classes } = this.props;

    return (
      <>
        <Typography noWrap className={classes.columnTitle} variant="subtitle2">
          {title}
        </Typography>
        {isColumnSortable && (
          <>
            {this.renderSortIcon(SORT_DIRECTION.ASC)}

            {this.renderSortIcon(SORT_DIRECTION.DESC)}
          </>
        )}
      </>
    );
  };

  renderColumnHeader = (columnNo, getSortProperty, title, GridProps) => {
    const { classes, setSortColumn, sortedColumnNo } = this.props;

    const isCurrentSortedColumn = columnNo === sortedColumnNo;

    const isColumnSortable = !!getSortProperty;

    return (
      <Grid
        item
        key={columnNo}
        onClick={getSortProperty ? () => setSortColumn(columnNo) : undefined}
        className={classNames(classes.column, {
          [classes.sortableColumn]: isColumnSortable,
          [classes.sortedColumn]: isCurrentSortedColumn && isColumnSortable,
          [classes.unsortedColumn]: !isCurrentSortedColumn && isColumnSortable,
        })}
        {...GridProps}
      >
        {this.renderTitle(title, isColumnSortable)}
      </Grid>
    );
  };

  render() {
    const {
      noborder,
      classes,
      columns,
      displayStatusIcon,
      actions,
    } = this.props;

    return (
      <Grid
        container
        wrap="nowrap"
        alignItems="center"
        className={classNames(classes.root, {
          [classes.rootBorder]: !noborder,
        })}
      >
        <Grid item className={classes.iconColumn} />
        <Grid container item xs>
          {columns.map(({ title, getSortProperty, xs }, index) =>
            this.renderColumnHeader(index, getSortProperty, title, {
              xs,
            }),
          )}
        </Grid>
        {actions ? (
          actions.map((action, index) => (
            <Grid key={index} item className={classes.iconColumn} />
          ))
        ) : (
          <>
            {/** TODO: Remove this after all lists are using actions */}
            {displayStatusIcon && <Grid item className={classes.iconColumn} />}
            <Grid item className={classes.iconColumn} />
          </>
        )}
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    background: theme.palette.background.default,
  },
  rootBorder: {
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  iconColumn: {
    width: 50,
    height: 50,
    minWidth: 50,
  },
  column: {
    textAlign: "left",
    height: 50,
    display: "flex",
    overflow: "hidden",
    alignItems: "center",
    padding: `0 ${theme.spacing(2)}px`,
  },
  columnTitle: {
    fontSize: "1rem",
    fontWeight: 700,
    alignItems: "center",
  },
  sortArrowIconDesc: {
    display: "none",
  },
  sortArrowIconAsc: {
    display: "none",
  },
  visibleArrowIcon: {
    display: "initial",
  },
  sortedColumn: {
    background: theme.palette.grey[100],
  },
  unsortedColumn: {
    "& $visibleArrowIcon": {
      display: "none",
    },
    "&:hover $sortArrowIconAsc": {
      display: "initial",
    },
    "&:hover": {
      background: theme.palette.grey[100],
    },
  },
  sortableColumn: {
    cursor: "pointer",
  },
});

SortableListHeader.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      getSortProperty: PropTypes.func,
    }),
  ),
};

SortableListHeader.defaultProps = {
  columns: [],
};

export default compose(withStyles(styles))(SortableListHeader);
